import React from 'react';
import { useLanguage } from '../../context/LanguageContext';
import './Intro.css';

const Intro = () => {
  const { tr } = useLanguage();
  const nameParts = tr.hero.name.split('\n');

  return (
    <section className="hero" id="inicio">
      <div className="hero-content">
        <p className="hero-greeting">{tr.hero.greeting}</p>
        <h1 className="hero-name">
          {nameParts.map((part, i) => (
            <span key={i}>{part}{i < nameParts.length - 1 && <br />}</span>
          ))}
        </h1>
        <h2 className="hero-role">{tr.hero.role}</h2>
        <p className="hero-tagline">{tr.hero.tagline}</p>
        <div className="hero-ctas">
          <a href="#contato" className="hero-btn-primary">{tr.hero.contactCta}</a>
          <a
            href="https://www.linkedin.com/in/joaocarvalhop"
            target="_blank"
            rel="noreferrer"
            className="hero-btn-secondary"
          >
            <img src="assets/icons8-linkedin.svg" alt="LinkedIn" />
            LinkedIn
          </a>
          <a
            href="https://github.com/joaocarvalhop"
            target="_blank"
            rel="noreferrer"
            className="hero-btn-secondary"
          >
            <img src="assets/icons8-github.svg" alt="GitHub" />
            GitHub
          </a>
        </div>
      </div>
      <div className="hero-visual" aria-hidden="true">
        <pre className="hero-code">{`const engineer = {
  focus:    "backend",
  systems:  "distributed",
  patterns: ["saga", "circuit-breaker",
             "event-driven"],
  tools:    ["kafka", "node", "typescript"],
};`}</pre>
      </div>
    </section>
  );
};

export default Intro;
